module.exports = __webpack_public_path__ + "img/palladiumWhitegold.cb69bf4.webp";